import {FormControl, InputAdornment, OutlinedInput} from '@mui/material';
import {ChangeEventHandler, MutableRefObject} from 'react';
import SearchIcon from '@icons/SearchIcon';

type TData = {
	start?: any,
	end?: any
}

interface IProps {
	placeholder: string;
	inputRef?: MutableRefObject<HTMLInputElement | undefined>;
	value?: string;
	onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	className?: string;
	data?: TData;
}

export default function SearchInput({placeholder, inputRef, value, onChange, className, data}: IProps) {
	return (
		<FormControl fullWidth variant="outlined" className={className}>
			<OutlinedInput
				value={value}
				inputRef={inputRef}
				sx={{
					bgcolor: (theme) => theme.palette.mode === 'light' ? 'grey.50' : 'grey.900',
					borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : 'grey.800'
				}}
				size="small"
				placeholder={placeholder}
				id="input-with-icon-adornment"
				onChange={onChange}
				startAdornment={
					<>
						{
							typeof data?.start !== 'undefined' &&
							<InputAdornment position="start" className="flex flex-row justify-center items-center">
								<div className="border-l border-l-black pl-2 pt-1">
									{data?.start}
								</div>
							</InputAdornment>
						}
					</>
				}
				endAdornment={
					<>
						<InputAdornment position="end">
							<SearchIcon/>
						</InputAdornment>
						{
							typeof data?.end !== 'undefined' &&
							<InputAdornment position="end" className="flex flex-row justify-center items-center">
								<div className="border-r border-r-black pr-2 pt-1">
									{data?.end}
								</div>
							</InputAdornment>
						}
					</>
				}
			/>
		</FormControl>
	);
}
